import PropTypes from "prop-types";
import React from "react";

class ProfileCard extends React.Component {
  render() {
    const profilePicStyle = {
      backgroundImage: `url(${this.props.profilePic})`
    };

    let url = this.props.link || "";
    const outputUrl = url.replace("https://www.facebook", "fb");

    return (
      <div className="profile-card animated fadeInUp color-text-heading">
        <div className="pic" style={profilePicStyle} />
        <div className="text">
          <h2 className="name color-text-heading font-heading">
            {this.props.name}
          </h2>
          <h3 className="link color-text-body font-heading">{outputUrl}</h3>
        </div>
      </div>
    );
  }
}

ProfileCard.propTypes = {
  profilePic: PropTypes.string,
  name: PropTypes.string,
  time: PropTypes.string,
  theme: PropTypes.string,
  link: PropTypes.string
};

export default ProfileCard;
